import React, { useEffect, useState } from "react";
import { GeoJSON } from "react-leaflet";
import L, { GeoJSON as LeafletGeoJSON, Map as LeafletMap } from "leaflet";

type MapLinkProps = {
    map?: L.Map;
    dataUrl: string;
    title: string;
    legend:string
    updateMapData: (newData: any) => void;
    updateMapTitle : (legend: string) => void;
  };

const MapLink: React.FC<MapLinkProps> = ({ map, dataUrl, updateMapData, title, updateMapTitle, legend}) => {
  const [geoJsonLayer, setGeoJsonLayer] = useState<LeafletGeoJSON | null>(null);

  const fetchNewData = async (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();  // Prevent the default behavior of the link
    try {
      const response = await fetch(dataUrl);
      const newData = await response.json();
      updateMapData(newData);  // Notify the parent component of the new data
      var totalEntrevistas = newData.reduce((sum : any, value : any) => (typeof value.cantidad == "number" ? sum + value.cantidad : sum), 0);
      updateMapTitle(legend + ' [' + totalEntrevistas + ']')
    } catch (error) {
      console.error("Error fetching new data:", error);
    }
  };

  return (
    <div>
      <a href="#" className="btn btn-sm btn-light me-1" onClick={fetchNewData}>{title}</a>
    </div>
  );
};

export default MapLink;